var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('catalog-product-list',{attrs:{"data-source":_vm.dataSource,"image-base-url":_vm.imageBaseUrl,"wishlist-items":_vm.wishlistItems,"customer-group-id":_vm.customerGroupId}})
}
var staticRenderFns = []

export { render, staticRenderFns }